// removed by extract-text-webpack-plugin
module.exports = {"classButtonContainer":"index-classButtonContainer-eebaa3e4","classLeft":"index-classLeft-ad91e216","classRight":"index-classRight-8039b178"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@automotivetech/buttonswitch/dist/static/media/index.css
// module id = 827
// module chunks = 0